import React, { useContext, useEffect, useState } from "react";
import {
    AddButton,
    CityDropdownForTrip,
    CommonInput,
    CrossButton,
    CustomSelect,
} from "components";
import { UserContext } from "context";
import StorageService from "utils/StorageServices/StorageServices";
import { errorSchema, utils } from "helper";
import { getStatesData } from "_services";
import {
    createMasterLocation,
    updateMasterLocation,
} from "_services/accountsServices/addressBookService";
import toast from "react-hot-toast";
import { getCityLocationList } from "_services/accountsServices/cityLocationService";

const AddMasterLocationModal = (props) => {
    let {
        isOpen,
        onClose,
        id,
        detailsData,
        callBackDropdownLocationUpdate = () => { },
        whileEditLocationAddNewLocation = true,
    } = props;

    const initi = {
        company_id: StorageService.getCompanyId(),
        name: "",
        consignor_id: "",
        location_id: "",
        address_line1: "",
        address_line2: "",
        state: {},
        city: {},
        pincode: "",
        contact_no: "",
        email_id: "",
        gst_no: '',
        gst_treatment_id: {},
        gst_state: {},
    };

    const { masterData, states, setStates } = useContext(UserContext);
    const [form, setForm] = useState(initi);
    const [formError, setFormError] = useState("");
    const [stateValue, setStateValue] = useState();
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [allState, setAllStates] = useState([]);

    useEffect(() => {
        if (stateValue) {
            handleOnChange("state", {
                label: stateValue?.name,
                value: stateValue?.name,
                lat: String(stateValue?.latitude) || "",
                long: String(stateValue?.longitude) || "",
            });
        }
    }, [stateValue]);

    useEffect(() => {
        if (detailsData) {
            setForm((pre) => {
                return {
                    ...pre,
                    consignor_id: detailsData?._id
                }
            })
        }
    }, [detailsData])

    useEffect(() => {
        if (id?.id) {
            getAddressBook(id?.id);
        }
    }, []);



    const fetchFromCity = async (search, page, limit) => {
        const res = await getCityLocationList({
            countryCode: "IN",
            stateCode: "",
            offset: page,
            limit,
            search,

        });
        if (res?.responseCode === 200) {
            const list = res?.data?.all_cities.map((c) => ({ ...c, _id: c.name, label: `${c.name}, ${c.stateName}` }))

            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            toast.error(res?.responseMessage);
        }
    };

    const getAddressBook = async (id) => {
        const locationDetails = detailsData?.locations?.find((i) => i?._id === id)

        setForm((prevForm) => ({
            ...prevForm,
            company_id: StorageService.getCompanyId(),
            name: locationDetails?.attention,
            consignor_id: detailsData?._id,
            location_id: locationDetails?._id,
            address_line1: locationDetails?.address_line1,
            address_line2: locationDetails?.address_line2,
            state: locationDetails?.state,
            city: locationDetails?.city,
            pincode: locationDetails?.pincode,
            contact_no: locationDetails?.contact_no,
            email_id: locationDetails?.email,
            gst_no: locationDetails?.gst_no,
            gst_treatment_id: masterData?.gst_type_list?.map((el) => {
                return {
                    label: el?.name,
                    value: el?.id
                }
            }).find((i) => i?.value == locationDetails?.gst_type),
            gst_state: locationDetails?.gst_state
            ,
        }));
    };



    const handleOnChange = async (name, value) => {
        const stateObj = { ...form, [name]: value };
        if (name === "gst_no") {
            let gstCode = parseInt(value.slice(0, 2), 10);
            stateObj['gst_state'] = utils.codeToStateNameObject[gstCode];
        }
        setForm(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addMasterLocationSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const getStatesByApi = async (countryCode, stateCode) => {
        try {
            let data = {
                countryCode: countryCode ? countryCode : "IN",
                stateCode: stateCode ? stateCode : "",
            };
            let response = await getStatesData(data);
            if (response?.responseCode === 200) {
                if (countryCode && stateCode) {
                    setStateValue(response?.data[0]);
                    return response?.data[0];
                } else {
                    const optionsState = response?.data?.map((d) => {
                        return {
                            ...d,
                            label: d?.name,
                            value: d?.name
                        };
                    });

                    StorageService.setStates(JSON.stringify([...optionsState]))
                    setAllStates([...optionsState]);
                }
            } else {
                if (response) {
                    toast.error(response?.responseMessage)
                }
            }
        } catch (error) {
            toast.error("An unexpected error occurred. Please try again.");
        }
    };

    const handleCityChange = (data) => {
        handleOnChange("city", {
            label: data?.name,
            value: data?.name,
            lat: String(data?.latitude) || "",
            long: String(data?.longitude) || "",
        });

        getStatesByApi(data?.countryCode, data?.stateCode);
    };



    const handleClick = async (e, action) => {
        e.preventDefault();
        const validationResult = await utils?.checkFormError(
            form,
            errorSchema.addMasterLocationSchema
        );

        if (validationResult == true) {
            setLoading(true);
            await apiCallingFunction(action);
            setFormError("");
        } else {
            setFormError(validationResult);
            setLoading(false);
        }
    };

    const apiCallingFunction = async (action) => {
        try {

            let object = {
                ...form,
                gst_treatment_id: form?.gst_treatment_id?.value,
                gst_state: {
                    value: form?.gst_state?.value,
                    label: form?.gst_state?.label,
                },
            };

            let updateObject = {
                ...form,
                gst_treatment_id: form?.gst_treatment_id?.value,
                gst_state: {
                    value: form?.gst_state?.value,
                    label: form?.gst_state?.label,
                },
                addressbook_id: props?.id?.id,
            };

            const res = props?.id?.id
                ? await createMasterLocation(updateObject)
                : await createMasterLocation(object);
            if (res?.responseCode == 200) {
                clearAll();
                setLoading(false);
                if (props?.id?.id) {
                    let el = res?.data?.location;
                    callBackDropdownLocationUpdate({ ...el, label: `${el?.attention} ${el?.gst_no ? `(${el?.gst_no})` : `(No Gst)`}`, value: el?._id })
                    toast.success("Loaction Updated Successfully");
                } else {
                    toast.success("Loaction Created Successfully");
                }

                if (action == "add") {
                    onClose();
                    clearAll();
                } else {

                    clearAll();
                }
            } else {
                if (res?.responseMessage) {
                    toast.error(`${res?.responseMessage}`);
                }
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        } finally {
            setIsButtonDisabled(false);
        }
    };




    const clearAll = () => {
        setForm({
            ...form,
            name: "",
            category: 1,
            associate_party_id: [],
            contact_no: "",
            email_id: "",
            address_line1: "",
            address_line2: "",
            state: {},
            city: {},
            pincode: "",
            code: "",
            zone_id: "",
            company_id: StorageService.getCompanyId(),
        });
    };



    useEffect(() => {
        if (form?.gst_treatment_id?.value === 1) {
            setForm((s) => ({
                ...s,
                gst_no: ''
            }))
        }
    }, [form?.gst_treatment_id])

    useEffect(() => {
        if (!id?.id) {
            if (masterData?.gst_type_list?.length > 0 && allState?.length > 0) {
                setForm((s) => ({
                    ...s,
                    gst_state: form?.state?.label ? {
                        label: form?.state?.label ? form?.state?.label : '',
                        value: form?.state?.value ? form?.state?.value : '',
                    } : {},
                    gst_treatment_id: masterData?.gst_type_list?.map((el) => {
                        return {
                            label: el?.name,
                            value: el?.id
                        }
                    })[0],

                    company_id: StorageService.getCompanyId()
                }));
            }
        }
    }, [masterData?.gst_type_list?.length > 0, allState?.length > 0, StorageService.getCompanyId, form?.state]);

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...form, [name]: item };
        setForm(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addAddressBookContinue);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }
    };

    useEffect(() => {
        getStatesByApi();
    }, [])

    return (
        <>
            <div className="offcanvas-header">
                <h5 className="offcanvas-title">
                    {" "}
                    {`${id?.id && !id.view ? "Edit" : id?.id && id.view ? "View" : "Add"
                        } Location for ${detailsData?.name}`}{" "}
                </h5>
                <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={() => onClose(!isOpen)}>
                    <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <path
                            d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                            fill="black" />
                    </svg>
                </CrossButton>
            </div>

            <div className="offcanvas-body">
                <div className="pr_procssBx">
                    <div className="pr_procssBx_grid">
                        <div className="singleDiv">
                            <CommonInput
                                type="text"
                                placeholder="Attention"
                                label="Attention"
                                labelRedStar={true}
                                name="name"
                                maxLength="40"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}
                                // onChange={({ target: { name, value } }) => {
                                //   handleOnChange(name, value);
                                // }}
                                value={form?.name}
                                focus={!!(typeof formError === "object" && formError?.name)}
                                error={!!(typeof formError === "object") ? formError?.name : ""}
                                disabled={id?.view}
                            />
                        </div>

                        <div className="singleDiv">
                            <div className="h4Head">Add Address</div>
                        </div>

                        <div className="singleDiv">
                            <CommonInput
                                type="text"
                                placeholder="Address"
                                label="Address Line 1"
                                name="address_line1"
                                value={form.address_line1}
                                focus={
                                    !!(
                                        typeof formError === "object" &&
                                        formError?.address_line1
                                    )
                                }
                                error={
                                    !!(typeof formError === "object")
                                        ? formError?.address_line1
                                        : ""
                                }
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                                disabled={id?.view}
                            />
                        </div>

                        <div className="singleDiv">

                            <CityDropdownForTrip
                                key={`fromLoction`}
                                label="City "
                                placeholder="Select a city"
                                fetchData={fetchFromCity}
                                isAddButton={whileEditLocationAddNewLocation ? true : false}
                                pageSize={20}
                                onChange={(data) => handleCityChange(data, "city")}
                                disabled={id?.view}
                                selectedItem={form?.city}
                                error={!!formError["city.label"]}
                                errorMessage={
                                    formError["city.label"]
                                }
                                withState={false}
                            />
                        </div>

                        <div className="halfDiv">
                            <CommonInput
                                type="text"
                                placeholder="State"
                                label="State"
                                name="state"
                                disabled={true}
                                value={form?.state?.label}
                                focus={
                                    !!(
                                        typeof formError === "object" &&
                                        formError["state.label"]
                                    )
                                }
                                error={
                                    !!(typeof formError === "object")
                                        ? formError["state.label"]
                                        : ""
                                }
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                            />
                        </div>

                        <div className="halfDiv">
                            <CommonInput
                                type="text"
                                placeholder="PIN Code"
                                label="PIN Code"
                                name="pincode"
                                maxLength={6}
                                value={form.pincode}
                                focus={
                                    !!(typeof formError === "object" && formError?.pincode)
                                }
                                error={
                                    !!(typeof formError === "object")
                                        ? formError?.pincode
                                        : ""
                                }
                                onChange={({ target: { name, value } }) => {
                                    if (/^\d*$/.test(value)) {
                                        handleOnChange(name, value);
                                        // setPhoneError("");
                                    }
                                }}
                                disabled={id?.view}
                            />
                        </div>

                        <div className="singleDiv">
                            <div className="h4Head">Other Contact</div>
                        </div>

                        <div className="singleDiv">
                            <CommonInput
                                type="text"
                                placeholder="Contact Number"
                                label="Contact Number"
                                name="contact_no"
                                maxLength="16"
                                value={form.contact_no}
                                focus={
                                    !!(typeof formError === "object" && formError?.contact_no)
                                }
                                error={
                                    !!(typeof formError === "object")
                                        ? formError?.contact_no
                                        : ""
                                }

                                onChange={({ target: { name, value } }) => {

                                    let cleanedValue = value.replace(/\D/g, '');
                                    if (cleanedValue.startsWith('91') && cleanedValue.length > 10) {
                                        cleanedValue = cleanedValue.substring(2);
                                    }
                                    if (/^\d{0,10}$/.test(cleanedValue)) {
                                        handleOnChange(name, cleanedValue);
                                    }
                                }}
                                disabled={id?.view}
                            />
                        </div>

                        <div className="singleDiv">
                            <CommonInput
                                type="email"
                                placeholder="Email ID"
                                label="Email ID"
                                name="email_id"
                                value={form.email_id}
                                focus={
                                    !!(typeof formError === "object" && formError?.email_id)
                                }
                                error={
                                    !!(typeof formError === "object")
                                        ? formError?.email_id
                                        : ""
                                }
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                                disabled={id?.view}
                            />
                        </div>
                        <div className="singleDiv">
                            <div className="h4Head">GST Details</div>
                        </div>
                        <div className='singleDiv'>
                            <CustomSelect
                                options={masterData?.gst_type_list?.map((el) => {
                                    return {
                                        label: el?.name,
                                        value: el?.id
                                    }
                                })}
                                name="gst_treatment_id"
                                label="GST Type"
                                value={masterData?.gst_type_list?.map((el) => {
                                    return {
                                        label: el?.name,
                                        value: el?.id
                                    }
                                }).find((i) => i?.value == form?.gst_treatment_id?.value)}
                                error={formError["gst_treatment_id.label"]}
                                onSelect={(data) => onhandleSelect(data, 'gst_treatment_id')}
                                placeholder="Select GST Type"
                                disabled={id?.view}
                            />
                        </div>

                        {
                            (form?.gst_treatment_id == 3 || form?.gst_treatment_id == 2 || form?.gst_treatment_id?.value == '2' || form?.gst_treatment_id?.value == '3') && (
                                <div className='singleDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="GST Number e.g. 09AAACH7409R1RR"
                                        label='GST Number'
                                        name='gst_no'
                                        maxLength={15}
                                        value={form.gst_no}

                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value.toUpperCase())
                                        }
                                        focus={!!(typeof formError === "object" && formError?.gst_no)}
                                        error={!!(typeof formError === "object") ? formError?.gst_no : ""}
                                        disabled={id?.view}
                                    />
                                </div>
                            )
                        }

                        <div className='singleDiv'>
                            <CustomSelect
                                options={allState}
                                name="gst_state"
                                label="GST State"
                                value={form?.gst_state}
                                error={formError["gst_state.label"]}
                                onSelect={(data) => onhandleSelect(data, 'gst_state')}
                                placeholder="Select GST State"
                                disabled={id?.view}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="offcanvas-footer">
                <React.Fragment>
                    {!id?.isDetailsOnly && (
                        <AddButton
                            onClick={(e) => handleClick(e, "add")}
                            disabled={id?.view || loading}
                            buttonTitle={
                                loading
                                    ? " Loading... "
                                    : props?.id?.id
                                        ? "Update Location"
                                        : "Add Location"
                            }
                            className={
                                loading ? "_addNewComm_btn_disable_" : "_addNewComm_btn"
                            }
                        />
                    )}

                    {!props?.id?.id && (
                        <button
                            className={
                                isButtonDisabled
                                    ? "_addNewComm_btn_disable_"
                                    : "_addNewComm_btn"
                            }
                            onClick={(e) => handleClick(e, "new")}
                            disabled={id?.view || isButtonDisabled}
                        >
                            {loading ? " Loading... " : 'Add & New'}
                        </button>
                    )}
                    <AddButton
                        onClick={onClose}
                        buttonTitle="Cancel"
                        className={
                            loading ? "_addNewComm_btn_disable_" : "_addNewComm_btn"
                        }
                    />
                </React.Fragment>
            </div>


        </>
    );
};

export default AddMasterLocationModal;
